import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 20px;

    .input-div {
        width: 100%;
        gap: 5px;
        display: flex;
        align-items: center;
    }

    .input-checkout {
        width: 100%;
    }

    .icon-copy {
        cursor: pointer;
        color: #666;
        transition: color 0.2s ease;
        
        &:hover {
            color: #B8860B;
        }
    }
`;